export const xAxisTable = (value: number) => {
  
  let xFactor = Math.pow(10, String(Math.trunc( value )).length-1)
  if (xFactor === 0) {
    return [0, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000] 
  } else {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map( e => e*xFactor)
  }
}
